module.exports = __webpack_public_path__ + "static/media/Team 28 Gaia - Tanya Mudge.229e3c1d.png";